import { Injectable } from '@angular/core';
import {
  DependencyGroup,
  DependencyTaskGroup,
  TaskDependenceRepository,
} from '@app/domain';
import { map, Observable } from 'rxjs';
import { TaskDependenceService } from '../api-clients';
import { TaskDependenceMapper } from '../mappers';

@Injectable()
export class TaskDependenceRepositoryImpl implements TaskDependenceRepository {
  private readonly _taskDependenceMapper = new TaskDependenceMapper();
  constructor(private readonly _taskDependenceService: TaskDependenceService) {}

  getByTaskGroup(taskGroupId: number | string): Observable<DependencyGroup[]> {
    const dependencyGroupDTO =
      this._taskDependenceService.getByTaskGroup(taskGroupId);
    return dependencyGroupDTO.pipe(
      map(dto => this._taskDependenceMapper.dependencyGroupToDomain(dto))
    );
  }

  getByTaskTemplate(
    groupId: number,
    taskTemplateId: number
  ): Observable<DependencyTaskGroup[]> {
    const dependencyTaskGroupDTO =
      this._taskDependenceService.getByTaskTemplate(groupId, taskTemplateId);
    return dependencyTaskGroupDTO.pipe(
      map(dto => this._taskDependenceMapper.dependencyTaskGroupToDomain(dto))
    );
  }

  deleteDependence(taskDependencyId: number): Observable<void> {
    return this._taskDependenceService.deleteDependence(taskDependencyId);
  }
}
